<template>
  <div>
    <div class="row mb-3">
      <div class="col-12 col-md-8 pr-md-0">
        <div class="fxTradingaccount" v-if="tradingAccountList.totalRecords > 0">
          <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="selectAccount accountType px-0">
              <a :class="parseInt(accountType) ? 'active' : ''" href="#" v-on:click.prevent="accountType = '1'; accountSelectFunc();">{{ $t("createLiveAccount") }}</a>
              <a href="#" :class="!parseInt(accountType) ? 'active' : ''" v-on:click.prevent="accountType = '0'; accountSelectFunc();">{{ $t("demoAccount") }}</a>
            </div>
            <div class="fxAcntinfo">
              <ul class="slider d-flex align-items-center justify-content-between">
                <li class="fxreorder" v-if="accountArray.totalRecords > 0" @click="flagAccountShow = !flagAccountShow">
                  <feather type="x" v-if="flagAccountShow"></feather>
                  <feather type="more-vertical" v-else></feather>
                </li>
              </ul>
              <div class="fxAcntinfolist" v-if="flagAccountShow">
                <div class="acntlist">
                  <draggable v-model="accountArray.records" class="scrollbar">
                    <transition-group>
                      <div class="acntDragList d-flex align-items-center justify-content-between" v-for="list in accountArray.records" :key="list.id">
                        <div class="d-flex align-items-center">
                          <img :src="'../../../../static/fxView/images/' + platformIcon[list.platform]" alt="Icon" style="width: 25px" class="mr-3"/>
                          {{ list.account_id }}
                        </div>
                        <feather type="menu" size="1em"></feather>
                      </div>
                    </transition-group>
                  </draggable>
                  <div class="acntSavechanges">
                    <a href="#" class="btn_sm prism_btn w-100" @click="priorityFunc()">{{ $t("saveChanges") }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tradingaccountList scrollbar mb-3 d-flex align-items-center" v-if="accountArray.totalRecords > 0">
            <div class="card mr-3" :class="list.id == id ? 'selected' : ''" v-for="list in accountArray.records" >
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between mb-4" >
                  <div class="left mr-4 d-flex align-items-center">
                    <div class="acnt_ico mr-2">
                      <img :src="'../../../../static/fxView/images/' + currency[list.currency.toUpperCase()]" class="data_currency" />
                      {{ list.currency }}
                    </div>
                  </div>
                  <div class="right d-flex align-items-center justify-content-between">
                    <div class="tradingacnt">
                      <small>{{ $t("tradAccId") }}</small>
                      <div class="tradeID">{{ list.account_id }}</div>
                    </div>
                    <!-- <div class="optionmenu" > <feather size="1rem" type="eye"></feather> </div> -->
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-4">
                  <div class="blance">
                    <small>{{ $t("Platform") }}</small>
                    <div class="fxamount d-flex align-items-center">
                      <!-- <img :src="'../../../../static/fxView/images/'+platformIcon[list.platform]" alt="Icon" width="1rem" class="mr-2" /> -->{{
                        list.platform
                      }}
                    </div>
                  </div>
                  <div class="blance">
                    <small>{{ $t("Leverage") }}</small>
                    <div class="fxamount">{{ list.leverage }}</div>
                  </div>
                </div>
              </div>
              <div class="depositwithdrw d-flex align-items-center homeaddFundBtn justify-content-between">
                <div @click="selectTradingAccountFunc(list)" title="Overview" class="overviewbtn">
                  {{ $t("Overview") }}
                  <feather class="arrowup" size="1rem" type="chevron-down"></feather>
                </div>
                <router-link
                  v-if="parseInt(list.demo_live) == 1"
                  :to="{ name: 'fxView.deposit', params: { account_id: list.account_id, act_account_id: list.act_account_id, currency: list.currency.toUpperCase() } }"
                  class="prism_btn btn_xs fundnowbtn"
                  @click.native="addFundEventTrack"
                >
                  {{ $t("AddFunds") }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="h-100" v-if="tradingAccountList.totalRecords == 0">
          <!-- {{ tradingAccountList.totalRecords }}----- {{ get_user.verified_status }} -->
          <div class="noTradingAccount radiusbold p-5 whiteBG mb-3 d-flex align-items-center justify-content-center h-100" v-if="tradingAccountList.totalRecords == 0 && parseInt(get_user.verified_status) != 1">
            <div class="text-center">
              <p class="mb-2 f-15">
                {{ $t("DontAny2") }}
                <router-link :to="handleCurrentStep() ? '/index' : ({name: 'fxView.support' , params: { 'tabName':'openRequest'}})">{{$t('clickHere')}}</router-link> 
                or
                {{ $t("WaitVerif2") }}
                <router-link :to="'/create-demo-account'" class="green">{{ $t("DemoAcc") }}</router-link>.
              </p>
            </div>
          </div>
          <div class="noTradingAccount radiusbold p-5 whiteBG mb-3 d-flex align-items-center justify-content-center" v-else >
            <div class="text-center">
              <p class="mb-2" v-if="accountType == '0'">
                {{ $t("DontAny") }}
                <!-- <span v-html="accountType == '1' ? 'live' : 'demo'"></span> {{ $t("TradACC") }} -->
                <router-link :to="'/create-demo-account'" class="green"> {{ $t("DemoAcc") }} </router-link>
              </p>
              <p class="mb-2" v-else-if="accountType == '1'">
                {{ $t("DontAny") }}
                <router-link to="/create-live-account" class="green" :class="parseInt(get_user.verified_status) == 1 ? '' : 'disabled'">{{ $t("LiveACC") }}</router-link>
                {{ $t("WaitVerif2") }}
                <router-link :to="'/create-demo-account'" class="green"> {{ $t("DemoAcc") }}</router-link>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <!---price feed section-------------------->
        <price-feed-section></price-feed-section>
      </div>
    </div>
    <div
      class="row"
      v-if="
        id != '' &&
        accountDetails != '' &&
        Object.keys(accountDetails).length > 0
      "
    >
      <div class="col-12 col-md-8 pr-md-0" v-if="id != ''">
        <!---------------------account detail section-------------------->
        <div class="fxaccountDetail">
          <app-balance-margin-section></app-balance-margin-section>

          <!------------open/close trades-------------------->
          <div class="fxOrders whiteBG radiusbold mb-3">
            <div class="d-none d-md-block">
              <div
                class="map-nav border-bottom p-2 d-flex align-items-center justify-content-between"
              >
                <ul class="d-flex align-items-center">
                  <li
                    :class="
                      selected_order_trade == 'openTrades' ? 'active' : ''
                    "
                    @click="selected_order_trade = 'openTrades'"
                  >
                    <a href="#"> {{ $t("openTrades") }}</a>
                  </li>
                  <li
                    :class="
                      selected_order_trade == 'closeTrades' ? 'active' : ''
                    "
                    @click="selected_order_trade = 'closeTrades'"
                  >
                    <a href="#"> {{ $t("ClosedTrades") }}</a>
                  </li>
                </ul>
                <router-link
                  :to="
                    selected_order_trade == 'openTrades'
                      ? '/open-trades'
                      : '/close-trades'
                  "
                  class="see_more"
                >
                  <feather type="arrow-right"></feather>
                </router-link>
              </div>
            </div>
            <div class="mapIco text-center whiteBG radiusbold">
              <h3
                class="tabtile d-block d-md-none"
                :class="selected_order_trade == 'openTrades' ? 'active' : ''"
                @click="selected_order_trade = 'openTrades'"
              >
                {{ $t("openTrades") }}
              </h3>
              <app-open-trades
                v-if="selected_order_trade == 'openTrades'"
                :pageName="'dashboard'"
              ></app-open-trades>
              <h3
                class="tabtile d-block d-md-none"
                :class="selected_order_trade == 'closeTrades' ? 'active' : ''"
                @click="selected_order_trade = 'closeTrades'"
              >
                {{ $t("ClosedTrades") }}
              </h3>
              <app-close-trades
                v-if="selected_order_trade == 'closeTrades'"
                :pageName="'dashboard'"
              ></app-close-trades>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-md-4"
        v-if="accountDetails != '' && Object.keys(accountDetails).length > 0"
      >
        <!---------------news section--------------------->
        <div class="news whiteBG radiusbold mb-3">
          <div
            class="map-nav border-bottom homegridTitle d-flex align-items-center justify-content-between"
          >
            <h3>{{ $t("News") }}</h3>
            <router-link
              class="see_more"
              :to="'/trade-news'"
              title="See More"
              data-placement="top"
              data-toggle="tooltip"
            >
              <!--<feather type="arrow-right"></feather>-->
              {{ $t("SeeMor") }}
            </router-link>
          </div>
          <div class="homeNewsIdeas homeNews scrollbar tradingIdeas">
            <div
              class="card"
              v-for="(list, index) in currentNews.records"
              v-if="currentNews.totalRecords > 0"
            >
              <div class="card-body">
                <h4 class="card-title">
                  <a href="#">{{ list.title }}</a>
                </h4>
                <p class="card-description card-text mb-2">
                  {{ list.description }}
                </p>
                <div
                  class="view-likes-block d-flex align-items-center justify-content-between"
                >
                  <div class="colRight d-flex align-items-center">
                    <div class="date">
                      <small class="d-flex align-items-center"
                        ><feather type="calendar" class="mr-2"></feather>
                        {{ dateFunction(list.published) }}</small
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-------------autochartist--------------------->
      <!-- <div class="col-12 col-md-4 pr-md-0">
                <div class="whiteBG radiusbold mb-3">
               
                    <div class="border-bottom homegridTitle d-flex align-items-center justify-content-between">
                        <h3>Ideas</h3>
                        <router-link class="see_more" :to="'/auto-chartist'" title="subscribe" data-placement="top" data-toggle="tooltip">
                            {{$t('SeeMor')}}
                        </router-link>
                    </div>
                    <div class="homeNewsIdeas scrollbar tradingIdeas">
                        <div class="card" v-for="(list, index) in autoChartist.records" v-if="autoChartist.totalRecords > 0">
                            <div class="card-body">
                                <h4 class="card-title">
                                    {{list.isin}} <sup v-if="list.side.toUpperCase()== 'BUY'" class="badge badge-pill badge-success">{{list.side}}</sup><sup class="badge badge-pill badge-danger" v-else>{{list.side}}</sup>
                                </h4>
                                <p class="mb-2">{{list.idea_title}}</p>
                                <div class="view-likes-block d-flex align-items-center justify-content-between">
                                    <div class="currency-info d-flex align-items-center">
                                        <div class="currency mr-3">
                                            {{list.isin}},
                                        </div>
                                        <span class="short">
                                            <span class="badge badge-pill badge-success">{{list.holding_period}}</span>
                                        </span>
                                    </div>
                                    <div class="colRight d-flex align-items-center">
                                        <div class="date d-flex align-items-center"><feather type="calendar" class="mr-2"></feather> {{list.date_created | moment("DD MMMM YYYY")}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                     
                </div>
            </div> -->
      <!------------economic calender--------------->
      <div class="col-12 col-md-6 pr-md-0">
        <div class="whiteBG radiusbold mb-3">
          <div
            class="map-nav border-bottom homegridTitle d-flex align-items-center justify-content-between"
          >
            <h3>{{ $t("EconomicCalendar") }}</h3>
            <router-link
              class="see_more"
              :to="'/economic-calendar'"
              title="See More"
              data-placement="top"
              data-toggle="tooltip"
            >
              <!--<feather type="arrow-right"></feather>-->
              {{ $t("SeeMor") }}
            </router-link>
          </div>
          <div
            class="homeNewsIdeas economicCalendar homeNews scrollbar tradingIdeas"
          >
            <div class="tablePmm table-responsive" v-if="economicCalData != ''">
              <table class="table pmmTable">
                <thead>
                  <tr>
                    <th>{{ $t("Time") }}</th>
                    <th>{{ $t("Country") }}</th>
                    <th>{{ $t("Event") }}</th>
                  </tr>
                </thead>

                <tbody
                  v-if="economicCalData != '' && !pageLoader"
                  v-for="(list, key) in economicCalData"
                >
                  <tr class="fxs_c_period">
                    <td colspan="3">
                      {{ key | moment("dddd, DD MMMM YYYY") }}
                    </td>
                  </tr>
                  <tr v-for="calenderDatewise in list">
                    <td class="nowrap">
                      {{ calenderDatewise.Date | moment("hh:mm a") }}
                    </td>
                    <!-- <td v-html="(list.Category != '' && list.Category != null)?list.Category : '-'"></td> -->
                    <td class="d-flex align-items-center">
                      <img
                        :src="
                          '../../../../static/fxView/images/country_images/' +
                          ((calenderDatewise || {}).Country || '').toLowerCase() +
                          '.svg'
                        "
                        class="data_currency"
                      />
                      {{ calenderDatewise.Country }}
                    </td>
                    <td
                      v-html="
                        calenderDatewise.Event != '' &&
                        calenderDatewise.Event != null
                          ? calenderDatewise.Event
                          : '-'
                      "
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!---------------news section--------------------->
      <div class="col-12 col-md-6" v-if="id == ''">
        <div class="news whiteBG radiusbold mb-3">
          <div
            class="map-nav border-bottom homegridTitle d-flex align-items-center justify-content-between"
          >
            <h3>{{ $t("News") }}</h3>
            <router-link
              class="see_more"
              :to="'/trade-news'"
              title="See More"
              data-placement="top"
              data-toggle="tooltip"
            >
              <!--<feather type="arrow-right"></feather>-->
              {{ $t("SeeMor") }}
            </router-link>
          </div>
          <div class="homeNewsIdeas homeNews scrollbar tradingIdeas">
            <div
              class="card"
              v-for="(list, index) in currentNews.records"
              v-if="currentNews.totalRecords > 0"
            >
              <div class="card-body">
                <h4 class="card-title">
                  <a href="#">{{ list.title }}</a>
                </h4>
                <p class="card-description card-text mb-2" v-html="list.description"></p>
                <div class="view-likes-block d-flex align-items-center justify-content-between">
                  <div class="colRight d-flex align-items-center">
                    <div class="date">
                      <small class="d-flex align-items-center"
                        ><feather type="calendar" class="mr-2"></feather>
                        {{ dateFunction(list.published) }}</small
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import openTrades from "../shared/tradingAccounts/open_trades_listing";
import closeTrades from "../shared/tradingAccounts/close_trades_listing";
import balanceMarginSection from "../tradingAccounts/balance_margin_section";
import priceFeedSection from "../tradingAccounts/price_feed";
import draggable from "vuedraggable";
import { fxViewMixins } from "@/plugins/fxView";
import { Const } from "@/plugins/fxView/provider/candle-history/lib/const.cls";
import moment from 'moment'
export default {
  name: "Dashboard",
  mixins: [fxViewMixins],
  data() {
    return {
      selected_order_trade: "openTrades",
      pageLoader: false,
      loaderFuncRun: "1",
      flagAccountShow: false,
      fxsymbolprice: "0",
      //==========================================
      accountType: "1",
      accountArray: {},
      platformIcon: {
        MT4: "platforn-icon-1.svg",
        MT5: "platforn-icon-3.svg",
        ACT: "platforn-icon-2.svg",
      },
      id: "",
    };
  },
  components: {
    draggable,
    appOpenTrades: openTrades,
    priceFeedSection: priceFeedSection,
    appCloseTrades: closeTrades,
    appBalanceMarginSection: balanceMarginSection,
  },
  methods: {
    priorityFunc() {
      let accountJson = {
        globalParams: {
          accounts: this.accountArray.records,
        },
        localParams: { parameter: this },
      };
      this._runGetAccountPriorityList(accountJson);
    },
    accountSelectFunc() {
      if (this.accountType == "1") {
        this.accountArray = {
          records: this.liveAccountList.records,
          totalRecords: this.liveAccountList.totalRecords,
        };
      } else {
        this.accountArray = {
          records: this.demoAccountList.records,
          totalRecords: this.demoAccountList.totalRecords,
        };
      }
    },
    selectTradingAccountFunc(getData) {
      if (this.id == getData.id) {
        this.id = "";
      } else {
        this.id = getData.id;
        if (getData != "") {
          let accountJson = {
            globalParams: {
              id: getData.id,
            },
            localParams: { parameter: this, getData: [getData] },
          };
          this._runAddLastSelectTradingAccount(accountJson);
        }
      }
    },

    listing() {
      if (this.$store.getters[Const.GET_AUTO_CHARTIST] != "") {
        this.loaderFuncRun = "0";
      }
      if (this.$store.getters[Const.GET_ECONOMIC_CALENDER_DATA] != "") {
        this.loaderFuncRun = "0";
      }
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: "",
          page: 1,
          perPage: 15,
        },
        localParams: { parameter: this, loaderFuncRun: this.loaderFuncRun },
      };
      this._runGetAutochartistData(inputJson);
      this._runGetEconomicCalData(inputJson);
      this._runGetCurrentNews(inputJson);
    },
    tradingAccountListFunc() {
      this._runGetTradingAccountList({
        globalParams: {},
        localParams: { parameter: this, demo_live: "1" },
      });
    },
    addFundEventTrack() {
      this.$trackEvent('CP+Dashboard+Fund');
    },
    dateFunction(getDate){
      let last_seen_date = getDate ? moment.utc(getDate, "YYYY-MM-DD HH:mm:ss").fromNow() : '';
      return last_seen_date;
    },
    handleCurrentStep() {
      let step = false;
      if (parseInt(this.get_user.step) != 5 && !this.get_user.edittedStepAfterLogin) {
        step = true;
      } else if (parseInt(this.get_user.step) != 6 && this.get_user.edittedStepAfterLogin === true) {
        step = true;
      } else if (parseInt(this.get_user.step) != 6 && !this.get_user.edittedStepAfterLogin && this.get_user.edittedStepAfterLogin === false) {
        step = true;
      } else {
        step = false;
      }
      return step;
    }
  },
  created() {
    this.$trackEvent('CP+Dashboard+Pageview'); 
    this.listing();
    this.tradingAccountListFunc();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/users/dashboard.vue